import React, { useContext, useState, useEffect } from 'react'
import MilestoneBarMultipleAssessments from '../MilestoneBarMultipleAssessments/MilestoneBarMultipleAssessments'
import MatrixMultipleAssessments from '../MatrixMultipleAssessments/MatrixMultipleAssessments'
import LanguageContext from '../../../Store/LanguageContext'
import MultipleAssessmentsContext from '../../../Store/MultipleAssessmentsContext'
import { translate } from '../../translate/translate'
import { CircularProgress } from '@mui/material'

const AssessmentDetails = () => {
  const langCtx = useContext(LanguageContext)
  const multipleAssessmentsCtx = useContext(MultipleAssessmentsContext)
  const { selectedDeploymentIds, fetchParishInsights, isLoadingParishInsights, currentAssessmentId, parishInsights } = multipleAssessmentsCtx
  
  // State for calculated years
  const [calculatedYears, setCalculatedYears] = useState(["2023-2024", "2024-2025"])

  const handleTranslate = (text, type) => {
    switch (langCtx.language) {
      case "Nederlands": {
        return translate(text, "dashboardCompareDutch", type)
      }
      default: {
        return text;
      }
    }
  }

  const handleCompare = async () => {
    if (selectedDeploymentIds.length !== 2) {
      return;
    }

    if (!currentAssessmentId) {
      return;
    }

    try {
      await fetchParishInsights(currentAssessmentId, selectedDeploymentIds);
    } catch (error) {
      // Failed to fetch parish insights
    }
  }
  // Calculate years based on parish insights data
  useEffect(() => {
    const calculateYears = () => {
      if (!multipleAssessmentsCtx.deployments || !parishInsights || parishInsights.length === 0) {
        return ["2023-2024", "2024-2025"]; // Default fallback
      }

      // Use the deployment IDs from parishInsights data
      const parishDeploymentIds = parishInsights?.map(p => p?.deploymentId);

      // Find the deployments that match the parish insights data
      const selectedDeployments = multipleAssessmentsCtx.deployments?.filter(deployment => 
        parishDeploymentIds?.includes(deployment?.deploymentId)
      );

      if (selectedDeployments?.length !== 2) {
        return ["2023-2024", "2024-2025"]; // Default fallback
      }

      const [firstDeployment, secondDeployment] = selectedDeployments;
      
      const calculateYear = (deployment) => {
        const currentDate = new Date(deployment?.createdat);
        const currentIndex = multipleAssessmentsCtx.deployments?.findIndex(d => d?.deploymentId === deployment?.deploymentId);
        
        let endDate;
        if (currentIndex < multipleAssessmentsCtx.deployments?.length - 1) {
          // Use the day before the next deployment's creation date
          const nextDeployment = multipleAssessmentsCtx.deployments?.[currentIndex + 1];
          endDate = new Date(nextDeployment?.createdat);
          endDate.setDate(endDate.getDate() - 1);
        } else {
          // If no next deployment, use current date
          endDate = new Date();
        }
        
        const startYear = currentDate.getFullYear();
        const endYear = endDate.getFullYear();
        
        return startYear === endYear ? `${startYear}` : `${startYear}-${endYear}`;
      };
      
      return [calculateYear(firstDeployment), calculateYear(secondDeployment)];
    };

    const years = calculateYears();
    setCalculatedYears(years);
  }, [parishInsights]);

  const findlocation = () => {
    let location = -1;
    let location2 = -1;
    
    // If parishInsights data is not present, return -1 for both locations
    if (!parishInsights || parishInsights.length === 0) {
      const statusTags = ["MW1", "MW3"];
      return { location: -1, location2: -1, statusTags, years: calculatedYears };
    }
    
    const locationoneinfo = parishInsights?.[0]?.averageTotalScore;
    if (locationoneinfo !== undefined && locationoneinfo !== null) {
      if (locationoneinfo < 60) {
        location = 0;
      } else if (locationoneinfo < 70) {
        location = 1;
      } else if (locationoneinfo < 75) {
        location = 2;
      } else if (locationoneinfo < 80) {
        location = 3;
      } else if (locationoneinfo < 85) {
        location = 4;
      } else {
        location = 5;
      }
    }
    
    const locationtwoinfo2 = parishInsights?.[1]?.averageTotalScore;
    if (locationtwoinfo2 !== undefined && locationtwoinfo2 !== null) {
      if (locationtwoinfo2 < 60) {
        location2 = 0;
      } else if (locationtwoinfo2 < 70) {
        location2 = 1;
      } else if (locationtwoinfo2 < 75) {
        location2 = 2;
      } else if (locationtwoinfo2 < 80) {
        location2 = 3;
      } else if (locationtwoinfo2 < 85) {
        location2 = 4;
      } else {
        location2 = 5;
      }
    }
    
    const statusTags = [parishInsights?.[0]?.deploymentTitle || "MW1", parishInsights?.[1]?.deploymentTitle || "MW3"];
    return { location, location2, statusTags, years: calculatedYears };
  }
  return (
    <div>
      <div className="box">
        <MilestoneBarMultipleAssessments from={'Dashboard'} {...findlocation()} />
        <MatrixMultipleAssessments />
        <div className="compare-container">
          <span>{handleTranslate("Note: Only 2 assessments can be selected at a time.", "note")}</span>
          <button onClick={handleCompare} disabled={isLoadingParishInsights || selectedDeploymentIds.length !== 2}>
            {isLoadingParishInsights ? <CircularProgress size={20} sx={{ color: 'white !important' }} /> : handleTranslate("Compare", "compare")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AssessmentDetails